export enum InventoryDocumentKind {
    GoodsReceipt = 'GoodsReceipt',
    GoodsReceiptAdjustment = 'GoodsReceiptAdjustment',
    GoodsIssue = 'GoodsIssue',
    GoodsIssueAdjustment = 'GoodsIssueAdjustment',
    InternalGoodsReceipt = 'InternalGoodsReceipt',
    InternalGoodsIssue = 'InternalGoodsIssue',
    Stocktaking = "Stocktaking"
}
